import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
import { MinusSVG, PlusSVG } from '@sbercloud/uikit-product-icons';
import { ButtonFunction } from '@snack-uikit/button';
import { InputPrivate } from '@snack-uikit/input-private';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function StepperWithAllowedValues(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    allowedValues = _ref.allowedValues,
    postfix = _ref.postfix;
  var _useState = useState(allowedValues.findIndex(function (item) {
      return item === value;
    })),
    _useState2 = _slicedToArray(_useState, 2),
    selectedIdx = _useState2[0],
    setSelectedIdx = _useState2[1];
  return /*#__PURE__*/_jsxs("div", {
    className: styles.input,
    children: [/*#__PURE__*/_jsx(ButtonFunction, {
      icon: /*#__PURE__*/_jsx(MinusSVG, {}),
      onClick: function onClick() {
        var newIdx = Math.max(selectedIdx - 1, 0);
        setSelectedIdx(newIdx);
        onChange(allowedValues[newIdx]);
      }
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.content,
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          width: "".concat(allowedValues[selectedIdx].toString().length * 8, "px")
        },
        children: /*#__PURE__*/_jsx(InputPrivate, {
          readonly: true,
          value: String(allowedValues[selectedIdx])
        })
      }), postfix && /*#__PURE__*/_jsx("div", {
        className: styles.postfix,
        children: postfix
      })]
    }), /*#__PURE__*/_jsx(ButtonFunction, {
      icon: /*#__PURE__*/_jsx(PlusSVG, {}),
      onClick: function onClick() {
        var newIdx = Math.min(selectedIdx + 1, allowedValues.length - 1);
        setSelectedIdx(newIdx);
        onChange(allowedValues[newIdx]);
      }
    })]
  });
}